import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    maxWidth: 300,
    marginTop: 20
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ChatIntroCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant='body1'>Welcome {props.profile.name}.</Typography>
        <Typography variant='body2'>Please wait to be connected with a recruiter.</Typography>
      </CardContent>
    </Card>
  );
}
